import { ReactElement } from 'react';
import { TextField } from '@ff-it/form';
import { CategoryField } from '../category/MediaCategoryField';
import { AllActivityTypesField, LanguageField } from 'components';
import { useFieldValue } from 'hooks';
import { OutletOrServiceCategoryKind } from './types';

export function OutletOrServiceCategoryForm(): ReactElement {
  const kind = useFieldValue<OutletOrServiceCategoryKind>('kind');
  return (
    <div className="container px-0 ml-0">
      <div className="form-row">
        <TextField name="name" label="Name" className="col-md-6" required />
      </div>
      <div className="form-row">
        <AllActivityTypesField name="type" label="Type" placeholder="Any type" className="col-md-3" />
        {kind === 'OUTLET' && (
          <LanguageField
            name="language"
            label="Language"
            className="col-md-3"
            help="Primary content or broadcast language"
          />
        )}
      </div>
      <div className="form-row">
        <CategoryField name="category" label="Category" className="col-md-6" help="Default category for products" />
      </div>
    </div>
  );
}
